module.exports = require('./dist/react-keyed-file-browser');
